// The Program's pills coming and going (DayTags.vue; Seán, 2026-10-29), with the Web Animations
// API: each pill's own measured width, so nothing grows bigger than it ends or leaves a gap. A pill
// coming grows from nothing, slightly smaller (scaled) and faded in once there's room; a pill going
// shrinks to nothing in place, its text faded first. All on one curve and duration, so the row's
// width moves one way only.

const EASING = "ease";
const SCALED = "scale(0.85)";

// the pill at its full size: its width and padding as laid out (its margins left to its class:
// the gap before it can change as its neighbours do)
function getFullSize(el) {
  const style = getComputedStyle(el);
  return {
    width: `${el.offsetWidth}px`,
    minWidth: style.minWidth,
    paddingLeft: style.paddingLeft,
    paddingRight: style.paddingRight,
    marginRight: "0px"
  };
}

// folded to nothing: its borders (never drawn under 1px, so left as they are) and its gap to the
// next pill taken back by its right margin, so it takes no room at all
function getFolded(el) {
  const style = getComputedStyle(el);
  const gap = parseFloat(getComputedStyle(el.parentElement).columnGap) || 0;
  const borders = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
  return {
    width: "0px",
    minWidth: "0px",
    paddingLeft: "0px",
    paddingRight: "0px",
    marginLeft: "0px",
    marginRight: `-${gap + borders}px`
  };
}

function animate(el, keyframes, durationMs, done) {
  el.style.overflow = "hidden";
  const animation = el.animate(keyframes, {duration: durationMs, easing: EASING});
  animation.onfinish = () => {
    el.style.overflow = "";
    done();
  };
}

export function getPillHooks(durationMs) {
  function onEnter(el, done) {
    const full = getFullSize(el);
    const keyframes = [
      {...getFolded(el), opacity: 0, transform: SCALED},
      {opacity: 0, offset: 0.4},
      {...full, opacity: 1, transform: "scale(1)"}
    ];
    animate(el, keyframes, durationMs, done);
  }
  function onLeave(el, done) {
    const keyframes = [
      {...getFullSize(el), opacity: 1, transform: "scale(1)"},
      {opacity: 0, offset: 0.45},
      {...getFolded(el), opacity: 0, transform: SCALED}
    ];
    animate(el, keyframes, durationMs, done);
  }
  return {onEnter, onLeave};
}
